import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _name$props$props$dat;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default (_name$props$props$dat = {
  name: 'EditorSlideUpload',
  props: {
    color: {
      type: String,
      default: '#1890ff'
    }
  }
}, _defineProperty(_name$props$props$dat, "props", ['color']), _defineProperty(_name$props$props$dat, "data", function data() {
  return {
    uploadUrl: '',
    downloadUrl: '',
    files: [],
    // color: '',
    dialogVisible: false,
    listObj: {},
    fileList: []
  };
}), _defineProperty(_name$props$props$dat, "created", function created() {
  this.init();
}), _defineProperty(_name$props$props$dat, "methods", {
  init: function init() {
    this.fileList = [];
    this.files = [];
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
  },
  handleSubmit: function handleSubmit() {
    this.$emit('successCBK', this.fileList);
    this.fileList = [];
    this.files = [];
    this.dialogVisible = false;
  },
  handleSuccess: function handleSuccess(response, file) {
    this.fileList.push({
      url: '/pic' + response.data[0].filePath + response.data[0].fileUrl,
      fileName: response.data[0].fileName,
      fileType: this.judgeFileType(file.raw.type)
    });
  },
  handleError: function handleError(err, file, fileList) {
    var res = JSON.parse(err.message);
    this.$message({
      message: res.message,
      type: 'error'
    });
  },
  // 删除图片
  handleRemove: function handleRemove(file, fileList) {
    var _this = this;

    var currentUrl = this.downloadUrl + file.response.data[0].fileId; // 获取当前删除文件的url
    // var currentFileName = response.data[0].fileName // 获取当前删除文件的文件名
    // var currentFileType = this.judgeFileType(file.raw.type) // 获取当前删除文件的文件类型

    this.fileList.forEach(function (item, index) {
      if (currentUrl === item.url) {
        _this.fileList.splice(index, 1);
      }
    });
  },
  // 判断上传的文件类型，方便数据库保存
  judgeFileType: function judgeFileType(str) {
    if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg') {
      return 2;
    } else {
      return 1;
    }
  },
  beforeUpload: function beforeUpload(file) {
    var extension = file.name.substring(file.name.lastIndexOf('.') + 1);
    extension = extension.toLowerCase();
    var isLt2M = file.size / 1024 / 1024 < 10;
    var fileFormatOK = extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif';

    if (!fileFormatOK) {
      this.$message({
        message: '只支持上传 jpg/png/gif 格式文件!',
        type: 'error'
      });
      return false;
    }

    if (!isLt2M) {
      this.$message({
        message: '上传文件大小不能超过 10MB!',
        type: 'error'
      });
      return false;
    }
  }
}), _name$props$props$dat);